import { useEffect } from "react";

// Restores the previous title on unmount so nested routes don't leak titles.
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
